<template>
  <div
    v-dnd="dndOptions"
    :class="$style.wrapper"
  >
    <slot :drag="drag" />
    <div
      v-if="drag || showAlways"
      :class="[$style.dnd, drag ? dndActiveClass : dndClass]"
    >
      <div :class="$style.inner">
        <slot
          name="text"
          :drag="drag"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { dnd } from '@/shared/legacy/lib/dnd';

export default {
  name: 'BaseDnd',
  directives: {
    dnd
  },
  props: {
    disabled: Boolean,
    showAlways: Boolean,
    dndClass: {
      type: String,
      default: null
    },
    dndActiveClass: {
      type: String,
      default: null
    }
  },
  emits: ['change'],
  data() {
    return {
      drag: false
    };
  },
  computed: {
    dndOptions() {
      return {
        onHover: this.handleHover,
        onDrop: this.onAttached
      };
    }
  },
  methods: {
    handleHover(drag) {
      if (!this.disabled) {
        this.drag = drag;
      }
    },
    onAttached(files) {
      if (!this.disabled) {
        this.$emit('change', files);
      }
    }
  }
};
</script>

<style module lang="less">
@import '~@less/common/variables.less';

.wrapper {
  position: relative;
  height: 100%;
}
.dnd {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: @whiteColor;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  line-height: 26px;
  text-align: center;
  z-index: 1;
  padding: 16px;
}
.inner {
  border-radius: 12px;
  border: 1px dashed #05050533;
  width: 100%;
  height: 100%;
  align-items: center;
  display: flex;
  justify-content: center;
}
</style>

<i18n lang="json">{}</i18n>
